class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    // SS: zapamiętaj wariant, który klient faktycznie dodał (gratis z Essential Upsell dokłada się osobno)
    document.addEventListener(
      'submit',
      (evt) => {
        const input = evt.target && evt.target.querySelector && evt.target.querySelector('[name="id"]');
        if (input && evt.target.closest('product-form')) this.addedVariantId = String(input.value);
      },
      true
    );
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event && event.source === 'product-form' && event.productVariantId) {
          this.addedVariantId = String(event.productVariantId);
        }
      });
    }
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const html = parsedState.sections && parsedState.sections[section.id];
      if (!target || !html) return;
      target.innerHTML =
        section.id === 'cart-notification-product'
          ? this.buildProductHTML(html, [])
          : this.getSectionInnerHTML(html, section.selector);
    });

    if (this.header) this.header.reveal();
    this.open();
    this.refreshGifts();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  // SS: najpierw produkt dodany przez klienta, pod nim gratisy (pozycje za 0 zł)
  buildProductHTML(html, giftKeys) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const items = Array.from(doc.querySelectorAll('[id^="cart-notification-product-"]'));
    const prefix = 'cart-notification-product-';
    const variantId = this.addedVariantId || '';
    const main =
      (variantId && items.find((item) => item.id.startsWith(`${prefix}${variantId}:`))) ||
      items.find((item) => item.id === `${prefix}${this.cartItemKey}`) ||
      items[0];
    if (!main) return '';

    let output = main.innerHTML;
    giftKeys.forEach((key) => {
      const gift = items.find((item) => item.id === `${prefix}${key}`);
      if (!gift || gift === main) return;
      const name = gift.querySelector('.cart-notification-product__name');
      if (name) name.insertAdjacentHTML('beforebegin', '<span class="ss-gift-row__badge">Gratis</span>');
      output += `<div class="ss-gift-row">${gift.innerHTML}</div>`;
    });
    return output;
  }

  async refreshGifts() {
    const token = (this.giftToken = Date.now());
    this.watchCartRequests(token);
    // zapasowe sprawdzenia, gdyby aplikacja dodała gratis innym sposobem
    for (const wait of [150, 450, 900, 1800]) {
      await new Promise((resolve) => setTimeout(resolve, wait));
      if (token !== this.giftToken || this.giftShown === token) return;
      await this.loadGifts(token);
    }
  }

  // reaguje od razu, gdy Essential Upsell skończy dodawać gratis do koszyka
  watchCartRequests(token) {
    if (this.cartObserver || typeof PerformanceObserver !== 'function') return;
    try {
      this.cartObserver = new PerformanceObserver((list) => {
        const hit = list
          .getEntries()
          .some((entry) => /\/cart\/(add|change|update)(\.js)?/.test(entry.name) && !/section_id=/.test(entry.name));
        if (hit && this.giftToken && this.giftShown !== this.giftToken && Date.now() - this.giftToken < 6000) {
          this.loadGifts(this.giftToken);
        }
      });
      this.cartObserver.observe({ type: 'resource', buffered: false });
    } catch (error) {
      this.cartObserver = null;
    }
  }

  async loadGifts(token) {
    const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    try {
      const [cart, html] = await Promise.all([
        fetch(`${cartUrl}.js`).then((response) => response.json()),
        fetch(`${window.location.pathname}?section_id=cart-notification-product`).then((response) => response.text()),
      ]);
      if (token !== this.giftToken || this.giftShown === token) return;
      const giftKeys = cart.items
        .filter((item) => item.final_line_price === 0 && String(item.variant_id) !== this.addedVariantId)
        .map((item) => item.key);
      const target = document.getElementById('cart-notification-product');
      if (target && giftKeys.length) {
        target.innerHTML = this.buildProductHTML(html, giftKeys);
        this.giftShown = token;
      }
    } catch (error) {
      console.error(error);
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
